import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=64135e5f&scoped=true"
import script from "./HistoryList.vue?vue&type=script&lang=js"
export * from "./HistoryList.vue?vue&type=script&lang=js"
import style0 from "./HistoryList.vue?vue&type=style&index=0&id=64135e5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64135e5f",
  null
  
)

export default component.exports